import { complainantContactReducer } from './complainantContactReducer'
import { hasSingleContact } from './hasSingleContact'

export const hasComplainantContactError = ({ touched, values }) => {
  const fieldMap = [
    'personal_email',
    'work_email',
    'complainant_home_phone',
    'complainant_cell_phone',
    'complainant_work_phone',
    'address',
    'city',
    'state',
    'zip'
  ]

  const contactFields = complainantContactReducer(values)

  const isTouched = arr => arr.filter(i => touched.hasOwnProperty(i)).length > 0
  return !hasSingleContact(contactFields) && isTouched(fieldMap)
}
